import styled from "styled-components";

export const Container = styled.main`
  
  iframe{
    width: 1200px;
    border-width: 0px;
    margin: 0 auto;
    display: block;
  }


`